import {lowerCase} from 'lodash'
import {Basic, Ventrata} from 'types'
import {formatMoney} from 'utils/formatMoney'
import {getUnitMap} from 'utils/getUnitMap'
import {getProductPricingFromUnit} from '../../utils/getProductPricingFrom'

type CostFromUnitProps = {
  product: Ventrata.Product
  currency: Basic.Currency
}

export const CostFromPerUnit = ({product, currency}: CostFromUnitProps) => {
  const firstOption = product.options[0]

  if (!firstOption) {
    return <div className="font-medium text-red-500">No options found</div>
  }

  const unitPricingFrom = getProductPricingFromUnit(product, currency)
  const unitMap = getUnitMap(firstOption)

  const adultPrice = unitPricingFrom?.[unitMap['ADULT']]
  const childPrice = unitPricingFrom?.[unitMap['CHILD']]

  if (adultPrice === undefined && childPrice === undefined) {
    return null
  }

  return (
    <div>
      {adultPrice !== undefined && (
        <div className="font-bold text-[18px]">
          {formatMoney(adultPrice, currency, {minimumFractionDigits: 0})} per {lowerCase(unitMap['ADULT'] && 'adult')}
        </div>
      )}
      {childPrice !== undefined && (
        <div className="text-text-secondary">
          {formatMoney(childPrice, currency, {minimumFractionDigits: 0})} per {lowerCase(unitMap['CHILD'] && 'child')}
        </div>
      )}
    </div>
  )
}
